import Vue from 'vue'
import 'bootstrap-select'
import 'bootstrap-select/dist/css/bootstrap-select.css'

Vue.directive('bselectpicker', {
  inserted (el) {
    $(el).selectpicker()
  },

  componentUpdated (el) {
    $(el).selectpicker('refresh')
  },

  unbind (el) {
    $(el).selectpicker('destroy')
  }
})



// WEBPACK FOOTER //
// ./src/directives/bselectpicker/index.js